function doQuantityValidation(Iw_product_variation) {
  var variation_id = Iw_product_variation.variation_id;
  var qty_selected = parseInt(Iw_product_variation.quantity());

  var qty_step = parseInt(Iw_product_variation.product_variation.data('qty-step'));
  var qty_min = parseInt(Iw_product_variation.product_variation.data('qty-min'));
  var qty_max = parseInt(Iw_product_variation.product_variation.data('qty-max'));

  if (isInt(qty_max) && qty_selected > qty_max && qty_max > 0) {
    return "<div id=\"validation_error_"+variation_id+"\" class=\"iw-validation-error\">La quantité doit être inférieure à " + qty_step + "</div>";
  }
  if (isInt(qty_min) && qty_selected < qty_min && qty_min > 0) {
    return "<div id=\"validation_error_"+variation_id+"\" class=\"iw-validation-error\">La quantité doit être supérieure à " + qty_step + "</div>";
  }
  if (isInt(qty_step) && (qty_selected % qty_step !== 0) && qty_step > 1) {
    return "<div id=\"validation_error_"+variation_id+"\" class=\"iw-validation-error\">La quantité doit être un multiple de " + qty_step + "</div>";
  }

  return true;
}

function isInt(number) {
  // Validate qty is_int @see https://stackoverflow.com/a/14794066 (if ES6 use Number.isInteger(val) instead)
  return parseInt(Number(number)) == number && !isNaN(parseInt(number, 10));
}

export { doQuantityValidation, isInt }
